//请自行添加语言资源
const xxlJobLog = {
  logId: '日志ID',
  executorHandler: '任务名称',
  filePath: '文件路径',
  createTime: '创建时间',
  msg: {}
};
export default xxlJobLog



// WEBPACK FOOTER //
// ./src/page/log/xxlJobLog/lang/xxlJobLog.zh.js